import {isMobileOnly, isTablet} from 'react-device-detect'
const isMobile = () => {

  if (isMobileOnly){
      return true
    }
    else if(isTablet){

      if(window.innerHeight < window.innerWidth){
        return false  
      }
      else{
      return true 
      }
    }
  else return false
 }

export default isMobile
